import './TestimonialsSection.css';

import { motion } from 'framer-motion';

interface Testimonial {
  id: number;
  name: string;
  title: string;
  quote: string;
}

const TestimonialsSection = () => {
  
  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: "Shaun Francis",
      title: "Chair and CEO of MedCan and Author of Eat, Move, Think: The Path to a Healthier, Stronger, Happier You",
      quote: "For anyone who wants to slow down, notice more, and reconnect to what truly matters."
    },
    {
      id: 2,
      name: "UJ Ramdas",
      title: "Founder of Intelligent Change. Creator of The Five Minute Journal and the Productivity Planner.",
      quote: "This book will help you understand yourself, your loved ones, and ultimately live a truly happier life..."
    },
    {
      id: 3,
      name: "Randall Craig",
      title: "CEO, Braintrust Professional Institute.",
      quote: "Practical, actionable, and easy to read."
    },
    {
      id: 4,
      name: "Julia Chung",
      title: "Co-Founder & CEO of Spring Planning, Financial Planner & Family Enterprise Advisor",
      quote: "Many of us are taught how to increase knowledge and create physical forms of wealth, but the tools to invest in our relationships are harder to find..."
    },
    {
      id: 5,
      name: "Urs Koenig",
      title: "former UN peacekeeper, author of Radical Humility: Be a Badass Leader and a Good Human",
      quote: "What makes a life truly happy? This research-backed guide cuts to the core—meaningful, trusting relationships..."
    }
  ];

  return (
    <section id="testimonials" className="py-8 bg-surface dark:bg-panel/90">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-6"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-theme-primary mb-3">
            testimonials
          </h2>
          <p className="text-center text-theme-secondary mb-4">
            About the book, konnect better: unlocking the power of your relationships
          </p>
          <div className="w-24 h-1 bg-secondary mx-auto mb-8"></div>
        </motion.div>

        <div className="testimonials-scroll-container">
          <div className="testimonials-scroll-wrapper">
            {testimonials.map((testimonial) => (
              <motion.div
                key={testimonial.id}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5, delay: testimonial.id * 0.1 }}
                className="testimonial-card"
              >
                <div className="testimonial-content">
                  <div className="quote-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-secondary/30">
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                    </svg>
                  </div>
                  <blockquote className="testimonial-quote">
                    "{testimonial.quote}"
                  </blockquote>
                  <div className="testimonial-author">
                    <p className="author-name">{testimonial.name}</p>
                    {testimonial.title && (
                      <p className="author-title">{testimonial.title}</p>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          
          <div className="scroll-indicator">
            <div className="scroll-text">Scroll to see more</div>
            <div className="scroll-arrows">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
